import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { childrenBusinessPageBreadcrumbs } from '@/pages/Business/config';
import { NavigateFunction } from 'react-router-dom';

export const monitoringPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [...childrenBusinessPageBreadcrumbs(navigate)];

export const routeDetailBreadcrumbs = (
  navigate: NavigateFunction,
  _routeId: string
): NavigateLink[] => [
  ...monitoringPageBreadcrumbs(navigate),
  {
    label: 'Gestión de Rutas',
    onClick: () => navigate('/business/monitoring'),
  },
];
